(function () {
  var closeBtn = document.getElementById('MobileMenuClose');
  var overlay = document.getElementById('MobileMenuOverlay');
  var isAnimating = false;

  function syncAnnouncementOffset() {
    var bar = document.querySelector('.announcement-bar');
    var height = bar ? bar.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--announcement-bar-offset', height + 'px');
  }

  function syncHeaderGroupHeight() {
    var wrapper = document.querySelector('.header-group-wrapper');
    var height = wrapper ? Math.ceil(wrapper.getBoundingClientRect().height) : 0;
    if (height > 0) {
      document.documentElement.style.setProperty('--header-group-height', height + 'px');
    }
  }

  function syncHeaderLayout() {
    syncAnnouncementOffset();
    syncHeaderGroupHeight();
    updateHeaderScrolledState();
  }

  function getHeaderContrastThreshold() {
    var styles = getComputedStyle(document.documentElement);
    var headerHeight = parseFloat(styles.getPropertyValue('--header-group-height')) || 140;
    var offset = parseFloat(styles.getPropertyValue('--header-hero-contrast-offset')) || 64;
    return headerHeight + offset;
  }

  function updateHeaderScrolledState() {
    if (!document.body.classList.contains('has-transparent-header')) return;

    var hero = document.querySelector('.section-hero');
    if (!hero) return;

    var scrolled = hero.getBoundingClientRect().bottom <= getHeaderContrastThreshold();
    document.body.classList.toggle('header-scrolled', scrolled);
  }

  function getMenuToggle() {
    return document.querySelector('.bhcr-header__nav-inner [data-menu-toggle]');
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMenuOpen() {
    return overlay && overlay.classList.contains('is-open');
  }

  function isMenuVisible() {
    return overlay && overlay.classList.contains('is-visible');
  }

  function setMenuHidden() {
    if (!overlay) return;
    overlay.classList.remove('is-visible', 'is-open', 'is-closing');
    overlay.setAttribute('aria-hidden', 'true');
  }

  function openMenu() {
    if (!overlay || isAnimating || isMenuOpen()) return;

    var openBtn = getMenuToggle();
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';

    if (prefersReducedMotion()) {
      overlay.classList.add('is-open');
      if (closeBtn) closeBtn.focus();
      return;
    }

    isAnimating = true;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
      });
    });

    overlay.addEventListener(
      'transitionend',
      function onOpenEnd(event) {
        if (event.target !== overlay || event.propertyName !== 'transform') return;
        overlay.removeEventListener('transitionend', onOpenEnd);
        isAnimating = false;
        if (closeBtn) closeBtn.focus();
      }
    );
  }

  function closeMenu() {
    if (!overlay || isAnimating || !isMenuOpen()) return;

    var openBtn = getMenuToggle();
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';

    if (prefersReducedMotion()) {
      setMenuHidden();
      if (openBtn) openBtn.focus();
      return;
    }

    isAnimating = true;
    overlay.classList.add('is-closing');
    overlay.classList.remove('is-open');

    var closeFallback = setTimeout(function () {
      overlay.removeEventListener('transitionend', onCloseEnd);
      overlay.classList.remove('is-closing');
      setMenuHidden();
      isAnimating = false;
      if (openBtn) openBtn.focus();
    }, 400);

    function onCloseEnd(event) {
      if (event.target !== overlay || event.propertyName !== 'transform') return;
      clearTimeout(closeFallback);
      overlay.removeEventListener('transitionend', onCloseEnd);
      overlay.classList.remove('is-closing');
      setMenuHidden();
      isAnimating = false;
      if (openBtn) openBtn.focus();
    }

    overlay.addEventListener('transitionend', onCloseEnd);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.bhcr-header__nav-inner [data-menu-toggle]')) return;
    event.preventDefault();
    openMenu();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function (e) {
    if (!overlay || !isMenuVisible()) return;
    if (e.key === 'Escape') {
      closeMenu();
      return;
    }
    if (e.key === 'Tab' && isMenuOpen()) {
      var focusable = Array.from(overlay.querySelectorAll('a[href], button:not([disabled])'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  });

  if (document.body.classList.contains('has-transparent-header')) {
    function initHeaderScrollContrast() {
      var hero = document.querySelector('.section-hero');
      if (!hero) return;

      updateHeaderScrolledState();

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateHeaderScrolledState();
          ticking = false;
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', updateHeaderScrolledState);

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(updateHeaderScrolledState).observe(hero);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeaderScrollContrast);
    } else {
      initHeaderScrollContrast();
    }
  }

  syncHeaderLayout();
  window.addEventListener('resize', syncHeaderLayout);

  if (typeof ResizeObserver !== 'undefined') {
    var announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      new ResizeObserver(syncHeaderLayout).observe(announcementBar);
    }

    var headerGroup = document.querySelector('.header-group-wrapper');
    if (headerGroup) {
      new ResizeObserver(syncHeaderLayout).observe(headerGroup);
    }
  }
})();
